import React, { Component } from 'react';
import { Meteor } from 'meteor/meteor';
import { isFunction } from 'lodash';
import PropTypes from 'prop-types';

import Styles from './styles';

let L;
let unloadMap;
let customAttribution;

class LeafletMap extends Component {
  leafletMap = null;

  state = {
    clientModulesReady: false,
    isMapLoaded: false
  };

  componentDidMount() {
    const { clientModulesReady } = this.state;
    if (!clientModulesReady) this.loadClientModules();
  }

  componentDidUpdate() {
    const { clientModulesReady } = this.state;
    if (clientModulesReady && isFunction(customAttribution) && isFunction(unloadMap))
      this.loadMap();
  }

  componentWillUnmount() {
    const { isMapLoaded } = this.state;
    if (isMapLoaded) unloadMap(this.leafletMap);
  }

  loadMap = () => {
    const { isMapLoaded } = this.state;
    const { mapId, updateMapState, isThumbnailMap } = this.props;
    if (!isMapLoaded) {
      this.leafletMap = L.map(mapId, {
        zoomControl: !isThumbnailMap,
        scrollwheel: !isThumbnailMap
      });
      updateMapState(true);
      customAttribution(this.leafletMap, !isThumbnailMap);
      if (isThumbnailMap) {
        this.leafletMap.dragging.disable();
        this.leafletMap.touchZoom.disable();
        this.leafletMap.doubleClickZoom.disable();
        this.leafletMap.scrollWheelZoom.disable();
        this.leafletMap.boxZoom.disable();
        this.leafletMap.keyboard.disable();
        if (this.leafletMap.tap) this.leafletMap.tap.disable();
      }
      this.setState({ isMapLoaded: true });
    }
  };

  timeout = ms => {
    return new Promise(resolve => setTimeout(resolve, ms));
  };

  async loadClientModules() {
    if (Meteor.isClient) {
      L = await import('leaflet');
      ({ unloadMap, customAttribution } = await import('../../../modules/leaflet-operations'));
      // si no ponemos este retardo, en servidores lentos no carga bien los estilos
      // optimizar
      await this.timeout(100);
      this.setState({ clientModulesReady: true });
    }
  }

  render() {
    const {
      deployEnv,
      hasSearchItem,
      headerType,
      height,
      isAtlas,
      isFixedHeight,
      isFullScreen,
      isRounded,
      isThumbnailMap,
      mapId
    } = this.props;
    return (
      <Styles.Map
        deployEnv={deployEnv}
        hasSearchItem={hasSearchItem}
        headerType={headerType}
        height={height}
        id={mapId}
        isAtlas={isAtlas}
        isFullScreen={isFullScreen}
        isFixedHeight={isFixedHeight}
        isRounded={isRounded}
        isThumbnailMap={isThumbnailMap}
      />
    );
  }
}

LeafletMap.defaultProps = {
  hasSearchItem: false,
  headerType: '1',
  height: '100vh',
  isAtlas: false,
  isFixedHeight: false,
  isFullScreen: false,
  isRounded: false,
  isThumbnailMap: false,
  updateMapState: () => console.warn('LeafletUpdateState not set')
};

LeafletMap.propTypes = {
  deployEnv: PropTypes.string.isRequired,
  hasSearchItem: PropTypes.bool,
  headerType: PropTypes.string,
  height: PropTypes.string,
  isAtlas: PropTypes.bool,
  isFixedHeight: PropTypes.bool,
  isFullScreen: PropTypes.bool,
  isRounded: PropTypes.bool,
  isThumbnailMap: PropTypes.bool,
  mapId: PropTypes.string.isRequired,
  updateMapState: PropTypes.func
};

export default LeafletMap;
